document.addEventListener('DOMContentLoaded', function () {
    let facets_url = false;
    if (window.collection_handle) {
        facets_url = `/collections/${collection_handle}?view=collection-facets`;
    }

    if (facets_url) {
        getItemsFacets(facets_url);
    }

    window.getItemsFacets = getItemsFacets;
    window.getActiveFacets = getActiveFacets;
    window.updateFormWithUrlParams = updateFormWithUrlParams;


});



function updateFormWithUrlParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const facetForm = document.getElementById('FacetFiltersFormMobile');
    if (facetForm) {
        const sortBy = urlParams.get('sort_by');
        if (sortBy) {
            addHiddenInput(facetForm, 'sort_by', sortBy);
        }
    }
}

function getItemsFacets(facets_url) {
    fetch(facets_url)
        .then(response => response.json())
        .then(data => {
            handleFacets(data, 'colors', 'color-facets', getColorDetails, 'filter.v.option.color', createFacetLabel, checkedIcon);
            if (Array.isArray(data.fabrics)) {
                suppressNativeFacetByValue('fabric', data.fabrics);
            }
            if ((window.allowed_collection_colors || '').trim() && Array.isArray(data.sizes)) {
                suppressNativeFacetByValue('size', data.sizes);
            }
        })
        .catch(error => console.error('Error fetching collection facets:', error));
}

function suppressNativeFacetByValue(filterClassSuffix, allowedValues) {
    const containers = document.querySelectorAll(`.filter--${filterClassSuffix}`);
    if (!containers.length) return;

    const allowed = new Set(
        allowedValues
            .map((value) => String(value).trim().toLowerCase())
            .filter(Boolean)
    );

    containers.forEach((container) => {
        const items = container.querySelectorAll('li.facets__item');
        items.forEach((item) => {
            const input = item.querySelector('input[type="checkbox"], input[type="radio"]');
            if (!input) return;
            if (input.checked) return;
            const value = (input.value || '').trim().toLowerCase();
            if (!allowed.has(value)) {
                item.remove();
            }
        });
    });
}

function handleFacets(data, key, elementId, getDetailsFunc, inputName, createLabelFunc, iconHtml = '', sortFunc = sortAlphabetic) {
    const listElement = document.getElementById(elementId);
    const allowedColors = (window.allowed_collection_colors || '')
        .split(',')
        .map((color) => color.trim().toLowerCase())
        .filter(Boolean);
    let columnCount = extractColumnCount(data.colors);
    if (columnCount > 7) {
        columnCount = 7;
    }
    listElement.style.display = 'block';  // Ensures it’s a block element
    listElement.style.setProperty('column-count', parseInt(columnCount)); // Apply column count
    if (data[key].length > 0 && data[key] && Array.isArray(data[key])) {
        listElement.innerHTML = '';
        let items = data[key];
        if (key === 'colors' && allowedColors.length > 0) {
            items = items.filter((item) => allowedColors.includes(String(item).trim().toLowerCase()));
        }
        items = items.sort(sortFunc);

        items.forEach((item, index) => {
            const listItem = document.createElement('li');
            listItem.className = 'list-menu__item facets__item';

            const label = createLabelFunc(item, index, inputName, getDetailsFunc, key);
            if (iconHtml) {
                label.insertAdjacentHTML('beforeend', iconHtml);
            }

            listItem.appendChild(label);
            listElement.appendChild(listItem);
        });

        const listItems = document.querySelectorAll(`li[facet-type="${key}"]`);
        listItems.forEach(item => {
            item.style.display = 'block';
        });
    }
}

function createFacetLabel(item, index, inputName, getDetailsFunc, key) {
    const label = document.createElement('label');
    label.setAttribute('for', `Filter-${inputName}-mobile-${key}-${index}`);
    label.className = 'facets__label facet-checkbox';

    const input = document.createElement('input');
    input.className = 'mobile-facets__checkbox';
    input.type = 'checkbox';
    input.name = inputName;
    input.value = item;
    input.id = `Filter-${inputName}-mobile-${key}-${index}`;
    label.appendChild(input);

    const spanHighlight = document.createElement('span');
    const spanLabel = document.createElement('span');
    spanLabel.className = 'facet-checkbox__text';
    if (getDetailsFunc) {
        const details = getDetailsFunc(item);
        if (details) {
            spanHighlight.style.backgroundColor = details;
            spanHighlight.className = 'mobile-facets__highlight';
            item = item.replace(/^Abstract\s+/i, '');
            spanLabel.textContent = item;
        } else {
            spanHighlight.style.backgroundColor = item;
            spanHighlight.className = 'mobile-facets__highlight';
            //let item = "Abstract Leopard Black"; // Example item
            item = item.replace(/^Abstract\s+/i, ''); // Removes "Abstract " if it's at the start of the string
            spanLabel.textContent = item.charAt(0).toUpperCase() + item.slice(1);
            // spanLabel.textContent = item.charAt(0).toUpperCase() + item.slice(1);
        }
    }
    else {
        spanLabel.textContent = item;
    }

    const tooltipText = spanLabel.textContent.trim();
    if (tooltipText) {
        label.title = tooltipText;
        label.setAttribute('aria-label', tooltipText);
        spanHighlight.title = tooltipText;
        spanHighlight.setAttribute('aria-hidden', 'true');
    }

    if (getSearchParams(input.name, input.value)) {
        input.checked = true;
        label.classList.add('active');
       // appendExistingRefinement(spanLabel.textContent);
    }

    label.appendChild(spanHighlight);
    label.appendChild(spanLabel);

    return label;
}

function sortAlphabetic(a, b) {
    return a.localeCompare(b, undefined, { sensitivity: 'base' });
}

function sortNumeric(a, b) {
    const aValue = parseInt(a);
    const bValue = parseInt(b);
    if (isNaN(aValue)) return 1;
    if (isNaN(bValue)) return -1;
    return aValue - bValue;
}

function getColorDetails(colorCode) {
    const formattedColorCode = colorCode
        .toLowerCase()
        .replace(/\s+/g, '-')      // Replace spaces with dashes
        .replace(/[^a-z0-9-]/g, '-'); // Replace any non-alphanumeric characters (except dashes) with dashes

    return `var(--color-${formattedColorCode})`;
}

function getSearchParams(name, value) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has(name) && urlParams.getAll(name).includes(value);
}

function appendExistingRefinement(filterLabel) {
    const FacetFiltersPillsForm = document.getElementById('FacetFiltersPillsFormDiv');
    const facetRemoveElement = document.createElement('facet-remove');
    const anchorElement = document.createElement('a');
    anchorElement.href = `javascript:void(0)`;
    anchorElement.className = 'active-facets__button active-facets__button--light';

    const spanElement = document.createElement('span');
    spanElement.className = 'active-facets__button-inner button button--tertiary';
    spanElement.textContent = filterLabel;

    anchorElement.appendChild(spanElement);
    facetRemoveElement.appendChild(anchorElement);
    FacetFiltersPillsForm.appendChild(facetRemoveElement);

    updateFacetsCountMessage();
}

function getActiveFacets() {
    const checkboxes = document.querySelectorAll('.mobile-facets__checkbox');
    const FacetFiltersPillsForm = document.getElementById('FacetFiltersPillsFormDiv');
    FacetFiltersPillsForm.innerHTML = '';

    let checkedCount = 0;
    checkboxes.forEach(function (checkbox) {
        if (checkbox.checked) {
            const label = checkbox.closest('label');
            const spanLabel = label.querySelector('.facet-checkbox__text').textContent;
            appendExistingRefinement(spanLabel);
            checkedCount++;
        }
    });

    if (checkedCount === 0) {
        updateFacetsCountMessage();
    }
}

function extractColumnCount(data){
    const size = data.length;

    let divisor = 1;

    if (size > 12) {
        divisor = 4;
    } else if (size > 8) {
        divisor = 3;
    } else if (size > 4) {
        divisor = 2;
    }

    let modulo = Math.ceil(size / divisor);
    let columnCount = Math.ceil(modulo);

    console.log('Column Count:', columnCount);
    return columnCount;
}

function capitalizeWords(str) {
    return str.toLowerCase().replace(/\b\w/g, function(letter) {
        return letter.toUpperCase();
    });
}